import React, {useEffect} from "react";
import "../styles/AboutPage.css";
import AboutCards from "../components/AboutCards";

const AboutPage = () => {

    useEffect(() => {
        const section = document.querySelector("#about");
        if (section) {
            const navbarHeight = 50;
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: sectionTop - navbarHeight,
                behavior: "smooth"
            });
        }
    }, []);

    return (
        <div className="container about-page">
            <h1 id="about" className="about-title">
                About me
            </h1>
            <AboutCards />
        </div>
    );
};

export default AboutPage;
